import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { dateLocales } from '../i18n';

interface DateTimePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  showTimeSelect?: boolean;
  minDate?: Date;
  placeholderText?: string;
  error?: string;
}

export function DateTimePicker({
  selected,
  onChange,
  showTimeSelect = true,
  minDate,
  placeholderText,
  error,
}: DateTimePickerProps) {
  const { t, i18n } = useTranslation();
  
  const finalPlaceholderText = placeholderText || t('forms.selectDateTime');
  const locale = dateLocales[i18n.language as keyof typeof dateLocales] || dateLocales.en;
  
  return (
    <div className="relative">
      <div className="relative">
        <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-custom z-10" />
        <ReactDatePicker
          selected={selected}
          onChange={onChange}
          showTimeSelect={showTimeSelect}
          dateFormat={showTimeSelect ? "PPp" : "PP"}
          minDate={minDate}
          placeholderText={finalPlaceholderText}
          className="w-full pl-10 pr-4 py-2 bg-dark border border-gray-custom/20 rounded-lg text-light placeholder-light/40 focus:border-gray-custom/40 focus:outline-none"
          wrapperClassName="w-full"
          timeIntervals={15}
          timeCaption={t('dateTime.timeCaption') || "Time"}
          popperClassName="z-[100]"
          locale={locale}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}